// Cobertura da tabela de preco sobre as variacoes ao vivo de um canal.
// Espelha o 422 `price_type_partial` de PATCH /api/channels/:slug e o
// `channel_coverage` de GET /api/admin/price-types?channel=<id>.
// Sem dependencias: testavel com node:test (web/test/price-coverage.test.ts).

export interface PartialCoverage {
  sem_preco: number;
  total: number;
  amostra: string[];
}

const fmt = (n: number): string => n.toLocaleString("pt-BR");

/** Le o 422 `price_type_partial` de um erro do axios; null para qualquer outro erro. */
export function partialCoverageFromError(err: unknown): PartialCoverage | null {
  const resp = (err as { response?: { status?: number; data?: { error?: string; details?: unknown } } } | null)?.response;
  if (resp?.status !== 422 || resp.data?.error !== "price_type_partial") return null;
  const d = resp.data.details as Partial<PartialCoverage> | undefined;
  if (!d || typeof d.sem_preco !== "number" || typeof d.total !== "number") return null;
  const amostra = Array.isArray(d.amostra) ? d.amostra.filter((x): x is string => typeof x === "string") : [];
  return { sem_preco: d.sem_preco, total: d.total, amostra };
}

/** "cobre 1.234 de 3.620 variações" (para o texto ao lado de cada tabela). */
export function coverageLabel(covers: number, total: number): string {
  return `cobre ${fmt(covers)} de ${fmt(total)} variações`;
}

/** true quando a tabela deixa alguma variacao ao vivo sem preco. */
export function isPartialCoverage(covers: number, total: number): boolean {
  return total > 0 && covers < total;
}

/** Aviso completo, sem jargao, com o numero na frente. */
export function partialWarning(tableLabel: string, cov: { sem_preco: number; total: number }): string {
  return (
    `A tabela "${tableLabel}" cobre ${fmt(cov.total - cov.sem_preco)} de ${fmt(cov.total)} variações deste canal; ` +
    `as outras ${fmt(cov.sem_preco)} não receberiam preço novo (as que já estão na loja ficam com o preço atual; as que ainda não estão ficam sem preço).`
  );
}
